const IconArrowLeft = (): JSX.Element => {
  return (
    <>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M23.4,3.7c0.5,0.5,0.5,1.3,0,1.9L8.9,20c-0.5,0.5-1.3,0.5-1.9,0l-6.6-6.6   c-0.5-0.5-0.5-1.3,0-1.9c0.5-0.5,1.3-0.5,1.9,0L8,17.2L21.6,3.7C22.1,3.2,22.9,3.2,23.4,3.7z"
      />
    </>
  );
};

export default IconArrowLeft;
